import { showToast } from '../../application/utils/toast.util';
import {client} from '../../core/stores';
import {ExerciseProps, InputEvent} from '../../application/types';
import {MUTATION_COURSE_CATEGORY, MUTATION_DELETE_PROGRAM} from '../../core/graphql/types';

export function MutationCourseCategory(category, setSubmitting: InputEvent, setProgress?:InputEvent ): Promise {
  return new Promise((resolve,reject) => {
    const {name} = category;
    if(!name){
      showToast({html: 'Para salvar um programa, você precisa preencher o nome', displayLength: 5000})
      const errors = {name: 'Campo obrigatório'}
      reject(errors);
      return false;
    }

    client('account').mutate({
      mutation: MUTATION_COURSE_CATEGORY, 
      variables: {...category},
      context: {
        fetchOptions: {
          useUpload: true,
          onProgress: (ev: ProgressEvent) => {
            if(setProgress) setProgress(ev.loaded / ev.total)
          },
          onAbortPossible: (abortHandler: any) => {
          }
        }
      },
    })
    .then(({data}) => {
      const {createOrUpdateCourseCategory} = data || {};
      const {courseCategory} = createOrUpdateCourseCategory;
      showToast({html: 'Categoria atualizado com sucesso!'});
      !!setSubmitting && setSubmitting(false);
      resolve({status: 'success', courseCategory})
    })
    .catch( err => {
      console.log('ERROR ==> ', err)
      setSubmitting(false);
      const errorMessage = err.graphQLErrors.map((error) => error.message).join(',');
      showToast({ html: 'Houve um erro na sua solicitação.' })
      showToast({ html: errorMessage })
      reject({status: 'error', message: errorMessage})
    });
  })
}

export function MutationDeleteCourseCategory(program, setSubmitting?: InputEvent, setProgress?: InputEvent) : Promise {
  return new Promise((resolve, reject) => {
    client('account').mutate({
      mutation: MUTATION_DELETE_PROGRAM, 
      variables: {id: program.id},
      context: {
        fetchOptions: {
          useUpload: true,
          onProgress: (ev: ProgressEvent) => {
            if(setProgress) setProgress(ev.loaded / ev.total)
          },
          onAbortPossible: (abortHandler: any) => {
          }
        }
      },
    })
    .then(response => {
      const {data} = response;
      const {deleteProgram} = data || {};
      const {program : programUpdated} = deleteProgram;
      showToast({html: 'Programa apagado com sucesso!'});
      !!setSubmitting && setSubmitting(false);
      resolve({status: 'success', program: programUpdated})
    })
    .catch( err => {
      console.log('ERROR MutationDeleteProgram ==> ', err)
      !!setSubmitting && setSubmitting(false);
      const errorMessage = err.graphQLErrors.map((error) => error.message).join(',');
      showToast({ html: 'Houve um erro na sua solicitação.' })
      showToast({ html: errorMessage })
      reject({status: 'error', message: errorMessage})
    });
  });
}